// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"235":"f2fee381d480732673e33c1d28fdfca2","531":"62d2627e62da386414175b068f93d7dd"}[chunkId] + ".js";
};